import { motion } from "framer-motion";
import { Pencil } from "lucide-react";

export default function CompilationStack({
  title,
  items,
  count,
  onClick,
  onEdit,
  isOwner = false,
}) {
  const previewItems = items.slice(0, 3);

  return (
    <div
      onClick={onClick}
      className="group cursor-pointer flex flex-col items-center gap-3 p-2 relative"
    >
      {/* Edit button - always visible */}
      {isOwner && onEdit && (
        <button
          onClick={(e) => {
            e.stopPropagation();
            onEdit(e);
          }}
          className="absolute top-0 right-0 z-10 p-1.5 rounded-full bg-gray-800/80 border border-gray-700 text-gray-400 hover:text-white hover:bg-gray-700 transition-colors"
        >
          <Pencil size={12} />
        </button>
      )}

      <div className="relative w-36 h-36 md:w-40 md:h-40">
        {previewItems.map((item, index) => {
          const stackPosition = index;

          return (
            <motion.div
              key={item.id}
              className="absolute w-full h-full rounded-2xl border border-gray-700 bg-gray-900 overflow-hidden shadow-2xl"
              style={{
                zIndex: previewItems.length - index,
              }}
              animate={{
                top: stackPosition * 8,
                left: stackPosition * 8,
                rotate: (stackPosition - 1) * 2,
              }}
              whileHover={{
                top: stackPosition * 4,
                left: stackPosition * 4,
                rotate: (stackPosition - 1) * 5,
                scale: 1.05,
              }}
              transition={{ type: "spring", stiffness: 300, damping: 20 }}
            >
              <img
                src={item.image}
                alt=""
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
              />
            </motion.div>
          );
        })}
      </div>

      <div className="text-center mt-4">
        <h3 className="font-bold text-white text-base group-hover:text-orange-400 transition-colors">
          {title}
        </h3>
        <p className="text-xs text-gray-500">{count} collections</p>
      </div>
    </div>
  );
}
